/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as styles from "./imageManagement.styles";

export interface ImageThumbnailGridProps {
    images: any[];
    activeIndex: number;
    onImageClick: (index: number) => void;
    onDeleteImage: (image: any) => void;
}

export function ImageThumbnailGrid({ images, activeIndex, onImageClick, onDeleteImage }: ImageThumbnailGridProps) {
    if (!images || images.length === 0) {
        return null;
    }

    return (
        <div className="mt-4">
            <h5>Uploaded Images</h5>
            <div className="d-flex flex-wrap">
                {images.map((image, index) => (
                    <div
                        key={image.id || index}
                        className="image-item m-3 position-relative text-center"
                        css={css`flex: 0 0 140px;`}
                    >
                        <div
                            className={`border border-1 p-3 rounded position-relative ${index === activeIndex ? "border-primary" : ""}`}
                            css={css`
                                ${styles.imgWrapperStyles}
                                cursor: pointer;
                                border-width: ${index === activeIndex ? "3px" : "1px"} !important;
                                &:hover {
                                    border-color: var(--bs-primary) !important;
                                }
                            `}
                            onClick={() => onImageClick(index)}
                        >
                            <img
                                src={image.data_url}
                                alt=""
                                height="100%"
                                width="100%"
                                style={{ objectFit: "cover" }}
                            />
                        </div>

                        <button
                            css={styles.closeButtonStyles}
                            onClick={(e) => {
                                e.stopPropagation();
                                onDeleteImage(image.original || image);
                            }}
                            title="Delete image"
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

